<template>
    <div class="contents">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main">
                        <h4 class="text-capitalize breadcrumb-title">Billing & Paket</h4>
                    </div>
                    
                    <div v-if="isExpired() && myPackage && myPackage.id" class="alert alert-danger d-flex align-items-center justify-content-between" role="alert">
                        <div>
                            <i class="fas fa-exclamation-triangle mr-2"></i>
                            <strong>Akun Anda Telah Expired!</strong> Silakan perpanjang langganan untuk melanjutkan menggunakan layanan.
                        </div>
                        <button @click="renewPackage" class="btn btn-primary btn-sm" :disabled="isRenewing">
                            <span v-if="isRenewing">Memproses...</span>
                            <span v-else>Pay With PayPal</span>
                        </button>
                    </div>
                    
                    <div v-if="!isLoading && !myPackageLoading" class="row">
                        <div class="col-lg-12">
                            <div class="card shadow-sm border-0 mb-30">
                                <div class="card-header bg-white border-bottom">
                                    <h5 class="mb-0">
                                        <i class="fas fa-box mr-2 text-primary"></i>
                                        Paket Saya
                                    </h5>
                                </div>
                                <div class="card-body p-30">
                                    <div v-if="myPackage && myPackage.name">
                                        <div class="row">
                                            <div class="col-md-6 mb-4">
                                                <div class="info-box">
                                                    <label class="info-label">Nama Paket</label>
                                                    <div class="info-value">{{ myPackage.name }}</div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 mb-4">
                                                <div class="info-box">
                                                    <label class="info-label">Expired At</label>
                                                    <div class="info-value">
                                                        <span :class="{'text-danger font-weight-bold': isExpired(), 'text-warning font-weight-bold': isExpiringSoon(), 'text-success': !isExpired() && !isExpiringSoon()}">
                                                            <i :class="{'fa-calendar-times': isExpired(), 'fa-calendar-check': !isExpired()}" class="fas mr-1"></i>
                                                            {{ myPackage.expired_at }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 mb-4">
                                                <div class="info-box">
                                                    <label class="info-label">Max Device</label>
                                                    <div class="info-value">{{ myPackage.device }}</div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 mb-4">
                                                <div class="info-box">
                                                    <label class="info-label">Max CS</label>
                                                    <div class="info-value">{{ myPackage.customer_service }}</div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 mb-4">
                                                <div class="info-box">
                                                    <label class="info-label">Max Link Rotator</label>
                                                    <div class="info-value">{{ myPackage.link_rotator }}</div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 mb-4">
                                                <div class="info-box">
                                                    <label class="info-label">Quota Pesan</label>
                                                    <div class="info-value">{{ myPackage.pesan }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="text-center p-40">
                                        <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
                                        <p class="text-muted">Anda belum memiliki paket aktif</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-center p-30">
                        <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        components: {

        },
        data() {
            return {
                isLoading: true,
                myPackageLoading: true,
                isRenewing: false,
                userExpiredAt: null,
                myPackage: {
                    id: "",
                    name: "",
                    pesan: "0",
                    device: "0",
                    customer_service: "0",
                    campaign: "0",
                    order_online: "0",
                    link_rotator: "0",
                    chat_widget: "0",
                    expired_at: "",
                    webhook_media_quota:0

                },
                withdrawableBalance: 0,
                user_balance: 0,
                packageList: [],
                extendURL: "",
                syncText: "Sinkronisasi dalam proses..."
            };
        },
        beforeDestroy(){
            this.$root.$off("toggle_modal", this.fnToggleModal);
            this.$root.$off("refresh_data", this.fnRefreshData);
        },
        async mounted() {
            this.fnToggleModal = (param) => {
                this.toggleModal(param);
            }
            this.$root.$on("toggle_modal", this.fnToggleModal);

            this.fnRefreshData = (param) => {
                if(param == "user") this.fetchUser()
            }
            this.$root.$on("refresh_data", this.fnRefreshData);

            await this.fetchUser()
            await this.fetchPacakge()
            if(this.$store.state.auth.user.level == 'user-agency'){
                await this.fetchAgencySetting()
            }

            this.isLoading = false
        },
        methods: {
            async fetchUser() {
                try {
                    let user_data = await this.$store.dispatch('user_detail')
                    let user = user_data.data.data.user
                    this.user_balance = user.balance || 0
                    this.withdrawableBalance = user.withdrawable_balance || 0
                    
                    // Store expired_at for isExpired check
                    this.userExpiredAt = user.expired_at ? moment(user.expired_at) : null
                    
                    // Fetch package information from user
                    this.myPackageLoading = true
                    if (user.package && user.package.id) {
                        // Package data is included in user response
                        this.myPackage.id = user.package.id
                        this.myPackage.name = user.package.name || 'N/A'
                    } else if (user.package_id) {
                        // Package not loaded, fetch it
                        await this.fetchPackageDetails(user.package_id)
                    }
                    
                    // Set user limits and expired date
                    this.myPackage.device = user.max_device == -1 || user.max_device == null ? "Unlimited" : user.max_device
                    this.myPackage.customer_service = user.max_cs == -1 || user.max_cs == null ? "Unlimited" : user.max_cs
                    this.myPackage.link_rotator = user.max_link_rotator == -1 || user.max_link_rotator == null ? "Unlimited" : user.max_link_rotator
                    this.myPackage.pesan = user.max_message == -1 || user.max_message == null ? "Unlimited" : user.max_message
                    
                    // Set expired date from user
                    if (user.expired_at) {
                        this.myPackage.expired_at = moment(user.expired_at).format('DD MMMM YYYY')
                    }
                    
                    this.myPackageLoading = false
                } catch (err) {
                    console.error('Error fetching user:', err)
                    this.$toast.error(err.response?.data?.message || 'Failed to fetch user data')
                    this.myPackageLoading = false
                }
            },
            async fetchPackageDetails(packageId) {
                try {
                    // Fetch package details if package_id exists but package object not loaded
                    let packages = await this.$store.dispatch('package_list')
                    let pkg = packages.data.data.packages.find(p => p.id === packageId)
                    if (pkg) {
                        this.myPackage.id = pkg.id
                        this.myPackage.name = pkg.name || 'N/A'
                    }
                } catch (err) {
                    console.error('Error fetching package details:', err)
                }
            },
            async fetchPacakge(){
                this.myPackageLoading = true
                try{
                    let packageList = await this.$store.dispatch('package_list')
                    let pkg = packageList.data.data.packages
                    let p = []

                    for(let i = 0; i < pkg.length; i++){
                        if(this.$store.state.auth.user.level == 'user-agency' && pkg[i].is_addon == 0){
                            continue
                        }

                        p.push(pkg[i])
                    }

                    for (let i = 0; i < p.length; i++) {
                        p[i].pesan = p[i].message_quota == "-1" ? "Unlimited" : p[i].message_quota
                        p[i].device = p[i].max_device == "-1" ? "Unlimited" : p[i].max_device
                        p[i].customer_service = p[i].max_cs == "-1" ? "Unlimited" : p[i].max_cs
                        p[i].campaign = p[i].max_campaign == "-1" ? "Unlimited" : p[i].max_campaign
                        p[i].order_online = p[i].max_order_online == "-1" ? "Unlimited" : p[i].max_order_online
                        p[i].link_rotator = p[i].max_link_rotator == "-1" ? "Unlimited" : p[i].max_link_rotator
                        p[i].chat_widget = p[i].max_chat_widget == "-1" ? "Unlimited" : p[i].max_chat_widget
                        p[i].webhook_media_quota = parseInt(p[i].webhook_media_quota)/1000000
                        if(p[i].id == this.myPackage.id){
                            p[i].isMyPackage = true
                        }else{
                            p[i].isMyPackage = false 
                        }
                    }

                    this.packageList = p
                }catch(err){
                    console.log(err)
                }
                this.myPackageLoading = false
            },
            toggleModal(param) {
                this.$modal.toggle(param);
            },
            formatRupiah(numb){
                const format = numb.toString().split('').reverse().join('');
                const convert = format.match(/\d{1,3}/g);
                const rupiah = 'Rp ' + convert.join('.').split('').reverse().join('')
                return rupiah
            },
            matchPackage(a, b){
                if(a == b){
                    return true 
                }else{
                    return false
                }
            },
            isExpired(){
                // Use userExpiredAt from fetched user data
                if (this.userExpiredAt) {
                    return this.userExpiredAt.isBefore(moment())
                }
                
                // Fallback to store if userExpiredAt not set
                if (this.$store.state.auth.user && this.$store.state.auth.user.expired_at) {
                    let expiredAt = moment(this.$store.state.auth.user.expired_at)
                    return expiredAt.isBefore(moment())
                }
                
                return false
            },
            isExpiringSoon(){
                if (!this.myPackage || !this.myPackage.expired_at) return false
                let expiredDate = moment(this.myPackage.expired_at, 'DD MMMM YYYY')
                let now = moment()
                let daysUntilExpiry = expiredDate.diff(now, 'days')
                return daysUntilExpiry <= 7 && daysUntilExpiry > 0
            },
            async fetchAgencySetting(){
                let setting = await this.$store.dispatch('agency_setting_user')
                this.extendURL = setting.data.data.setting.extend_url
            },
            async sync(){
                try{
                    await this.$store.dispatch('package_sync', {})
                    this.syncText = "Sinkronisasi berhasil, silakan refresh halaman ini"
                }catch(err){
                    this.syncText = "Sinkronisasi gagal, pastikan email di v2 dan v3 sama atau kontak admin"
                    this.$toast.error(err.response.data.message)
                }
            },
            async renewPackage() {
                if (!this.myPackage || !this.myPackage.id) {
                    this.$toast.error("Anda tidak memiliki paket aktif")
                    return
                }
                
                this.isRenewing = true
                try {
                    // Create renewal invoice and get PayPal checkout URL (all done in backend)
                    let response = await this.$store.dispatch('invoice/invoice_renew_package')
                    
                    if (!response || !response.data || !response.data.success) {
                        const errorMsg = response?.data?.message || "Gagal membuat invoice pembaruan"
                        this.$toast.error(errorMsg)
                        return
                    }
                    
                    if (!response.data.data) {
                        this.$toast.error("Response tidak valid dari server")
                        return
                    }
                    
                    let checkoutURL = response.data.data.checkout_url
                    
                    // Redirect to PayPal
                    if (checkoutURL) {
                        window.location.href = checkoutURL
                    } else {
                        this.$toast.error("Gagal mendapatkan link pembayaran")
                    }
                } catch (err) {
                    console.error('Error renewing package:', err)
                    console.error('Error details:', err.response)
                    const errorMessage = err.response?.data?.message || err.message || "Gagal memperpanjang langganan"
                    this.$toast.error(errorMessage)
                } finally {
                    this.isRenewing = false
                }
            }
        },
    };
</script>

<style scoped>
    .nav-link{
        cursor: pointer !important;
    }

    .pricing__tag_new{
        font-size: 13px;
        line-height: 1.5384615385;
        font-weight: 500;
        padding: 7px 22px;
        color: black;
    }

    .blackBorder{
        border: 3px solid black;
    }

    .info-box {
        padding: 15px;
        background: #f8f9fa;
        border-radius: 8px;
        transition: all 0.3s ease;
    }

    .info-box:hover {
        background: #e9ecef;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    }

    .info-label {
        font-size: 12px;
        color: #6c757d;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 5px;
        display: block;
        font-weight: 600;
    }

    .info-value {
        font-size: 16px;
        color: #212529;
        font-weight: 500;
    }

    .card {
        border-radius: 12px;
        overflow: hidden;
    }

    .card-header {
        padding: 20px 30px;
        font-weight: 600;
    }

    .alert {
        border-radius: 8px;
        padding: 15px 20px;
        margin-bottom: 25px;
    }
</style>
